module.exports = __webpack_public_path__ + "img/arms-bg6.85fc2606.png";